export default import.meta.ROLLDOWN_FILE_URL_tdGc9SJKZi0EdOY8VH_pQA